module.exports = __webpack_public_path__ + "img/pagination-docs-right.481f4c31.svg";